import React, { useState } from 'react'

const GridColumnHeader = (props) => {
  const { iconName, headerName, sortIcon, data, setData, type, colKey, gridHeader, handleGridHeader } = { ...props }
  const sortOrderTypeName = ['asc', 'desc', 'default'];
  const [sortOrderType, setSortOrderType] = useState(0)
  // console.log(gridHeader.activeSortIcon )
  const handleAlphabetSort = (type, colKey) => {
    ////=====To set icon to default in non active elements====///
    handleGridHeader({ activeSortIcon: colKey })
    ////=====sorting on basis of Data Type and Sorting Type====///
    const sortedData = [...data];
    let res = sortedData.sort((a, b) => {
      
      // const valA = type === "string" ? a[colKey].toLowerCase() : a[colKey];
      // const valB = type === "string" ? b[colKey].toLowerCase() : b[colKey];

      // add these line due to some time faacing null data 
      const valA = type === "string" ? (a[colKey]?.toString().toLowerCase() || "") : a[colKey];
      const valB = type === "string" ? (b[colKey]?.toString().toLowerCase() || "") : b[colKey];
       


      let comparison = 0;
      if (valA > valB) { comparison = 1; }
      else if (valA < valB) { comparison = -1; }
      if (type === "number") { return sortOrderTypeName[sortOrderType] === 'asc' ? valA - valB : sortOrderTypeName[sortOrderType] === 'desc' && valB - valA; }
      if (type === "string") { return sortOrderTypeName[sortOrderType] === 'asc' ? comparison : sortOrderTypeName[sortOrderType] === 'desc' && -comparison; }
      if (type === "date") {
        const dateA = a[colKey].split("/")
        const A = `${dateA[2]}-${dateA[0]}-${dateA[1]}`
        const dateB = b[colKey].split("/")
        const B = `${dateB[2]}-${dateB[0]}-${dateB[1]}`

        return sortOrderTypeName[sortOrderType] === 'asc' ? new Date(A) - new Date(B) : sortOrderTypeName[sortOrderType] === 'desc' && new Date(B) - new Date(A);
      }
    })
    sortOrderTypeName[sortOrderType] === 'default' ? setData(gridHeader.defaultData) : setData(res);
    setSortOrderType(sortOrder => sortOrder < 2 ? sortOrder + 1 : 0)
  }
  return (
    <>
      <div className="column-container gap-2">
        <span>
          {/* <i className={iconName}></i> */}
          {headerName}</span>
        {sortIcon &&
          (gridHeader?.activeSortIcon === colKey ?
            (<span className='d-flex' onClick={() => handleAlphabetSort(type, colKey)}>
              {sortOrderType === 0 && <span class="icon-sorting fs-15 "></span>}
              {sortOrderType === 1 && <span class="icon-sorting-up fs-15"><span class="path1"></span><span class="path2"></span></span>}
              {sortOrderType === 2 && <span class="icon-sorting-down fs-15"><span class="path1"></span><span class="path2"></span></span>}
            </span>) :
            (<span className='d-flex' onClick={() => handleAlphabetSort(type, colKey)}>
              {<i className="icon-sorting fs-15" />}
            </span>))}
      </div>
    </>
  )
}

export default GridColumnHeader